// @flow

import React from 'react'
import { Link } from 'gatsby'

type Props = {
  isDisabled?: boolean,
  isButton?: boolean,
  buttonType?: string,
  isExternalLink?: boolean,
  ctaURL?: string,
  ctaText: string,
  color: string,
  fullWidth?: boolean,
}

const Cta = ({
  isButton,
  buttonType = "button",
  isDisabled,
  isExternalLink,
  ctaURL,
  ctaText,
  color,
  fullWidth = true,
}: Props) => {
  const Content = () => (
    <div
      className="flex items-center justify-center px-4 py-2 font-bold text-center text-white transition-colors duration-150 ease-linear md:inline-flex md:py-1 rounded-xl"
      style={{ backgroundColor: `#${color}` }}
    >
      {ctaText}
    </div>
  )

  if (isDisabled) return (
    <div className={`${fullWidth ? "w-full" : ""} cursor-pointer md:w-auto`}>
      <Content />
    </div>
  )

  return (
    <>
      {isButton ? (
        <button type={buttonType} className="focus:outline-none">
          <Content />
        </button>
      ) : (
        <>
          {(ctaURL.charAt(0) === "/" && !isExternalLink) && (
            <Link to={ctaURL} className="w-full md:w-auto">
              <Content />
            </Link>
          )}
          {(ctaURL.charAt(0) !== "/" || isExternalLink) && (
            <a target="_blank" rel="noopener noreferrer" href={ctaURL} className="w-full md:w-auto">
              <Content />
            </a>
          )}
        </>
      )}
    </>
  )
}

export default Cta
